export class Product {
    productId: any;
    questionType: any;
    statusId: any;
    bankId: any;
    listId: any;
    status: any;
}

export class ProductOffer {
  product: any;
  questionAnswer: any;
  bankId: any;
  partPaymentMonth: any;
  partPaymentAmount: any;
  newRate: any;
  completedTenure: any;
  pcr: any;
  withdrawalMonth: any;
  withdrawalAmount: any;
  taxSavings: any;
  taxRate: any;
  questionSetId: any;
  penalty: any;
  partPayment = [];
  recurringMonth: any;
  recurringAmount: any;
  ReducedEmi: any;
  originalEmi: any;
  savingsInEmi: any;
  outstandingTenure: any;
  reducedTenure: any;
  changeInRate: any;
  questionId: any;
  rangeSliderValue: any;
  amount: any;
  locationId: any;
  listType: any;
  roi: any;
  partPaymentRate: any;
  gender: any;
  salaryAccountBank: any;
  groupId: any;
  offer: any;
  companyName: any;
  loanAmount: any;
  currentDate: any;
  contactNumber: any;
  salary: any;
  tenure: any;
  residencyId: any;
  statusId: any;
  status: any;
  iscategory: any;
  questionType: any;
  leadId: any;
  email: any;
  name: any;
  age: any;
  city:any;
  emi:any;
  statusName: any;
  calculatorurl: any;
 
}


// WEBPACK FOOTER //
// ./src/app/calculators/Product.ts